"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Waveform = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Waveform, _React$Component);
  function Waveform(_props) {
    var _this;
    _classCallCheck(this, Waveform);
    _this = _callSuper(this, Waveform, [_props]);
    _defineProperty(_assertThisInitialized(_this), "drawWave", function (props) {
      var waveCanvas = document.createElement('canvas');
      waveCanvas.width = props.width;
      waveCanvas.height = props.height;
      var waveCtx = waveCanvas.getContext('2d');
      waveCtx.fillStyle = props.color;
      // draw wave
      for (var i = 0; i < props.width; i += 1) {
        var min = 1.0;
        var max = -1.0;
        for (var j = 0; j < props.step; j += 1) {
          var datum = props.channelData[i * props.step + j];
          if (datum < min) {
            min = datum;
          } else if (datum > max) {
            max = datum;
          }
          waveCtx.fillRect(i, (1 + min) * (props.height / 2), 1, Math.max(1, (max - min) * (_this.props.height / 2)));
        }
      }
      _this.setState({
        waveurl: waveCanvas.toDataURL()
      });
    });
    _defineProperty(_assertThisInitialized(_this), "drawLines", function () {
      var ctx = _this.refs.barcanvas.getContext('2d');
      ctx.clearRect(0, 0, _this.props.width, _this.props.height);
      if (_this.props.selection) {
        var t = _this.props.selection;
        // if select item, draw bars for selected
        _this.drawBar(ctx, t.start, t.color);
        _this.drawBar(ctx, t.end, t.color);
      } else {
        // else draw all bars
        var t2 = _this.props.timings;
        for (var i = 0; i < t2.length; i++) {
          _this.drawBar(ctx, t2[i].start, t2[i].color);
          _this.drawBar(ctx, t2[i].end, t2[i].color);
        }
      }
      // draw position bar
      _this.drawBar(ctx, _this.props.audio.currentTime * 1000, _this.props.color);
    });
    _defineProperty(_assertThisInitialized(_this), "drawBar", function (ctx, time, color) {
      ctx.fillStyle = color;
      ctx.fillRect(_this.milliToPx(time), 0, 2, _this.props.height);
    });
    _defineProperty(_assertThisInitialized(_this), "milliToPx", function (time) {
      return _this.props.width * (time / (_this.props.duration ? _this.props.duration : _this.props.audio.duration));
    });
    _defineProperty(_assertThisInitialized(_this), "pxToMilli", function (px) {
      return Math.round(px / _this.props.width * (_this.props.duration ? _this.props.duration : _this.props.audio.duration));
    });
    _defineProperty(_assertThisInitialized(_this), "getCoord", function (e) {
      var totalOffsetX = 0;
      var totalOffsetY = 0;
      var canvasX = 0;
      var canvasY = 0;
      var currentElement = _this.refs.barcanvas;

      // eslint-disable-next-line no-cond-assign
      do {
        totalOffsetX += currentElement.offsetLeft - currentElement.scrollLeft;
        totalOffsetY += currentElement.offsetTop - currentElement.scrollTop;
      } while (currentElement = currentElement.offsetParent);
      canvasX = event.pageX - totalOffsetX; // eslint-disable-line no-restricted-globals
      canvasY = event.pageY - totalOffsetY; // eslint-disable-line no-restricted-globals

      return {
        x: canvasX,
        y: canvasY
      };
    });
    _defineProperty(_assertThisInitialized(_this), "mouseDown", function (e) {
      var x = _this.getCoord(e).x;
      var hit = false;
      var clickTolerance = 2;
      for (var i = 0; !hit && i < _this.props.timings.length; i++) {
        var time = _this.props.timings[i].start;
        var px = _this.milliToPx(time);
        if (x > px - clickTolerance && x < px + clickTolerance) {
          hit = true;
          _this.refs.barcanvas.onmousemove = _this.mouseMove;
          _this.setState({
            drag: true,
            tindex: i,
            tprop: 'start'
          });
        }
        if (!hit) {
          time = _this.props.timings[i].end;
          px = _this.milliToPx(time);
          if (x > px - clickTolerance && x < px + clickTolerance) {
            hit = true;
            _this.refs.barcanvas.onmousemove = _this.mouseMove;
            _this.setState({
              drag: true,
              tindex: i,
              tprop: 'end'
            });
          }
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "mouseUp", function (e) {
      if (_this.state.drag) {
        _this.refs.barcanvas.onmousemove = null;
        _this.props.play();
        _this.setState({
          drag: false
        });
        _this.props.onTimingChange();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "mouseMove", function (e) {
      if (_this.state.drag) {
        _this.props.timings[_this.state.tindex][_this.state.tprop] = _this.pxToMilli(_this.getCoord(e).x);
      }
    });
    _this.state = {
      waveurl: null,
      drag: false
    };
    return _this;
  }
  _createClass(Waveform, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.refs.barcanvas.onmousedown = this.mouseDown;
      this.refs.barcanvas.onmouseup = this.mouseUp;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      if (!this.state.waveurl && props.channelData && props.step) {
        this.drawWave(props);
        // setup draw ticker
        this.drawInterval = setInterval(this.drawLines, this.props.update);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.drawInterval);
      this.drawInterval = null;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          position: 'relative',
          width: this.props.width,
          height: this.props.height + 10
        }
      }, this.state.waveurl ? '' : 'Loading Waveform', /*#__PURE__*/_react["default"].createElement("img", {
        ref: "wavecanvas",
        alt: "",
        width: this.props.width,
        height: this.props.height,
        src: this.state.waveurl,
        style: {
          position: 'absolute',
          left: 0,
          top: 0,
          zIndex: 0
        }
      }), /*#__PURE__*/_react["default"].createElement("canvas", {
        ref: "barcanvas",
        width: this.props.width,
        height: this.props.height,
        style: {
          position: 'absolute',
          left: 0,
          top: 0,
          zIndex: 1
        }
      }));
    }
  }]);
  return Waveform;
}(_react["default"].Component);
_defineProperty(Waveform, "propTypes", {
  play: _propTypes["default"].func.isRequired,
  audio: _propTypes["default"].object,
  timings: _propTypes["default"].array.isRequired,
  selection: _propTypes["default"].object,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  color: _propTypes["default"].string,
  step: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  update: _propTypes["default"].number,
  channelData: _propTypes["default"].object,
  onTimingChange: _propTypes["default"].func
});
_defineProperty(Waveform, "defaultProps", {
  audio: null,
  selection: null,
  width: 800,
  height: 100,
  color: 'black',
  step: 1,
  update: 21,
  onTimingChange: function onTimingChange() {}
});